var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "vitrine" } },
    [
      _c(
        "carousel",
        {
          staticClass: "carousel",
          attrs: {
            autoplay: true,
            perPage: 1,
            paginationEnabled: true,
            autoplayHoverPause: true,
            loop: true,
            autoplayTimeout: 10000
          }
        },
        [
          _c("slide", { staticClass: "slide" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "content col-md-12" }, [
                  _c("h2", { staticClass: "title" }, [
                    _vm._v(
                      "\n                Empoderamos pessoas que fazem o bem,\n                para que elas façam ainda mais!\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                Sua Organização Social necessita de apoio para fomentar as arrecadações e melhorar a comunicação com seus doadores? A Click2Giv tem as ferramentas que você precisa!\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/create-project", href: "" } },
                        [_vm._v("Cadastre sua ONG")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "image" }, [
              _c("img", {
                staticClass: "img-responsive",
                attrs: { src: _vm.vitrine1 }
              })
            ])
          ]),
          _vm._v(" "),
          _c("slide", { staticClass: "slide" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "content col-md-12" }, [
                  _c("h2", { staticClass: "title" }, [
                    _vm._v(
                      "\n                “Nós acreditamos no bem e nas pessoas que fazem o bem!”\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                Conectamos pessoas que querem de alguma maneira contribuir e ajudar, com Organizações Sociais que necessitam de contribuições.\n                Escolha uma entidade que toca o seu coração e participe como puder!\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/signup", href: "" } },
                        [_vm._v("Cadastre-se")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "image" }, [
              _c("img", { attrs: { src: _vm.vitrine2 } })
            ])
          ]),
          _vm._v(" "),
          _c("slide", { staticClass: "slide" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "content right col-md-12" }, [
                  _c("h2", { staticClass: "title" }, [
                    _vm._v(
                      "\n                Descontos do Bem: uma rede que transforma vidas!\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                Você gosta de promoções e descontos? Está procurando uma oferta especial?\n                Aqui você encontra centenas de lojas, descontos especiais e ao comprar um produto você ajuda uma Organização Social cadastrada em nossa plataforma.\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "button" }, [
                    _c(
                      "a",
                      { attrs: { href: "/descontosdobem", target: "_blank" } },
                      [_vm._v("Conheça")]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "image" }, [
              _c("img", { attrs: { src: _vm.vitrine3 } })
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23b6a5e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b6a5e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Vitrine.vue
// module id = null
// module chunks = 